import '../App.css';
import '../Rent/rent.css'
import camaro from '../zz.images/camaro.jpg'
import miata from '../zz.images/miata.jpg'
// import outback2008 from '../zz.images/2008outback.jpg'
import outback2008_2 from '../zz.images/2008outback_2.jpg'
import outback2017 from '../zz.images/2017outback.jpg'
import pilot from '../zz.images/pilot.jpg'

function Rent() {

	function hondaClick() {
		window.open("https://turo.com/us/en/suv-rental/united-states/union-city-ca/honda/pilot/491985");
	}

	function miataClick() {
		window.open("https://turo.com/us/en/car-rental/united-states/mountain-house-ca/mazda/mx-5-miata-rf/510452");
	}

	function outback2017Click() {
		window.open("https://turo.com/us/en/suv-rental/united-states/mountain-house-ca/subaru/outback/800006");
	}

	function camaroClick() {
		window.open("https://turo.com/us/en/car-rental/united-states/mountain-house-ca/chevrolet/camaro/753392");
	}

	function outback2008Click() {
		window.open("https://turo.com/us/en/car-rental/united-states/mountain-house-ca/subaru/outback/832197");
	}

	return (
		<div className="App">
			<head>
				<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
					integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous"></link>
				<script src="https://code.jquery.com/jquery-3.2.1.slim.min.js"
					integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous">
				</script>
				<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js"
					integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous">
				</script>
				<script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js"
					integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous">
				</script>
			</head>

			<div id="root"></div>

			<div class="topnav">
				<a href="/home">Home</a>
				<a class="active" href="/rent">Rent</a>
				<a href="/contact">Contact</a>
				<a href="/about">About</a>
			</div>

			<div class="jumbotron">
				<div class="container text-center">
					<h1>Our Fleet</h1>
					<p>All of these vehicles can be rented through Turo.</p>
				</div>
			</div>

			<div class="container-fluid bg-3 text-center">
				<div class="row">
					<div class="col-sm-3">
						<img src={pilot} class="carImg img-responsive" alt="Honda Pilot"></img>
						<p>2018 Honda Pilot</p>
						<p>SUV • Automatic • Seats 8</p>
						<button onClick={hondaClick} class="btn" type="button"><span>Rent</span></button>
					</div>
					<div class="col-sm-3">
						<img src={miata} class="carImg img-responsive" alt="Mazda Miata"></img>
						<p>2018 Mazda MX-5 (Miata)</p>
						<p>Sports Car • Manual • Seats 2</p>
						<button onClick={miataClick} class="btn" type="button"><span>Rent</span></button>
					</div>
					<div class="col-sm-3">
						<img src={outback2017} class="carImg img-responsive" alt="2017 Subaru Outback"></img>
						<p>2017 Subaru Outback</p>
						<p>SUV • Automatic • Seats 5</p>
						<button onClick={outback2017Click} class="btn" type="button"><span>Rent</span></button>
					</div>
					<div class="col-sm-3">
						<img src={camaro} class="carImg img-responsive" alt="Chevrolet Camaro"></img>
						<p>2016 Chevrolet Camaro</p>
						<p>Sports Car • Manual • Seats 4</p>
						<button onClick={camaroClick} class="btn" type="button"><span>Rent</span></button>
					</div>
					<div class="col-sm-3">
						<img src={outback2008_2} class="carImg img-responsive" alt="2008 Subaru Outback"></img>
						<p>2008 Subaru Outback</p>
						<p>Wagon • Manual • Seats 5</p>
						<button onClick={outback2008Click} class="btn" type="button"><span>Rent</span></button>
					</div>
				</div>
			</div><br></br>
		</div>
	);
}

export default Rent;
